module.exports = __webpack_public_path__ + "static/silver-f9dde710e25598921c255edd7a6dc922.svg";